export default __webpack_public_path__ + "static/media/inmobiliaria-idiliovistania-flag.0d25233c.png";